export default {
  dialog: {
    backdropStyle:
      'fixed inset-0 md:py-30 bg-alpha-black-70 z-51 overflow-hidden sm:py-30 war-modal z-20 md:w-full mx-auto',
  },
  psWidget: 'ps-widget',
};
